import { Text } from '@chakra-ui/react'

import { ElementProps } from '../../GenericElement/GenericElement'

const Header: React.FC<ElementProps> = () => {
  return (
    <Text as="h5" className="thick" ml={4} data-testid="editItem-title">
      Edit Image
    </Text>
  )
}

export default Header
